/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import ToolTip from '../../../../../elements/ToolTip';

function FxRateApply({ fxRate, labelText, tooltipText, buttonText, onApply, className, buttonId, tabIndex }) {
  if (!Number.isFinite(fxRate) || fxRate === null) return null;

  return (
    <div className={`text-sm leading-snug flex flex-col text-gray-700 ${className}`}>
      <div className="flex items-center gap-2">
        <label htmlFor={buttonId} className="font-medium">
          {labelText}
        </label>
        <p>{fxRate.toFixed(2)}</p>
        <ToolTip info={tooltipText} />
      </div>
      <div className="flex items-center w-full mt-1">
        <div className="flex gap-2 items-center w-full">
          <button
            type="button"
            id={buttonId}
            className="rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500"
            onClick={onApply}
            tabIndex={tabIndex}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}

FxRateApply.propTypes = {
  fxRate: PropTypes.number,
  labelText: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onApply: PropTypes.func.isRequired,
  className: PropTypes.string,
  buttonId: PropTypes.string,
  tabIndex: PropTypes.number,
};

FxRateApply.defaultProps = {
  fxRate: null,
  className: '',
  buttonId: 'fx-rate-button',
  tabIndex: 0,
};

export default FxRateApply;
